
export const compareTextWithTextSearch = (
  text: string,
  textSearch: string,
): boolean => {
  const words = text.toLowerCase().split(' ');
  const firstCharInWord = words.map(word => word[0]).join('');
  return firstCharInWord.includes(textSearch.toLowerCase());
};
